(() => {
  if (window.PCHeader) { window.PCHeader.init(); return; }
  let dispose;
  function init() {
    dispose?.();
    const header = document.querySelector('[data-pc-header]');
    const shell = header?.closest('[data-pc-header-shell]');
    const burger = document.getElementById('pcBurger');
    const menu = document.getElementById('pcMobileMenu');
    if (!header || !shell || !burger || !menu) return;
    const abort = new AbortController(), signal = abort.signal;
    let open = false, oldOverflow = '', background = [], frame = 0;
    const nav = [...header.querySelectorAll('a[data-pc-scroll]')];
    const marked = [...shell.querySelectorAll('a[data-pc-scroll]')];
    const sync = () => {
      frame = 0;
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--pc-header-height', height + 'px');
      header.dataset.scrolled = String(scrollY > 24);
      if (open) menu.style.top = header.getBoundingClientRect().bottom + 'px';
      let current;
      for (const link of nav) {
        const target = document.getElementById(link.hash.slice(1));
        if (target && target.getBoundingClientRect().top <= height + 100) current = link.hash;
      }
      marked.forEach(link => { if (current && link.hash === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
    };
    function close(restoreFocus = false) {
      if (!open) return;
      open = false;
      shell.removeAttribute('role'); shell.removeAttribute('aria-modal'); shell.removeAttribute('aria-label');
      header.dataset.menuOpen = 'false';
      burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', burger.dataset.labelOpen);
      menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); menu.inert = true;
      document.body.classList.remove('pc-mobile-nav-open');
      document.body.style.overflow = oldOverflow;
      background.forEach(([el, inert]) => { el.inert = inert; }); background = [];
      if (restoreFocus) burger.focus({preventScroll:true});
    }
    function show() {
      open = true; oldOverflow = document.body.style.overflow;
      shell.setAttribute('role', 'dialog'); shell.setAttribute('aria-modal', 'true'); shell.setAttribute('aria-label', shell.dataset.menuLabel);
      header.dataset.menuOpen = 'true';
      burger.classList.add('open'); burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', burger.dataset.labelClose);
      menu.inert = false; menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pc-mobile-nav-open');
      menu.scrollTop = 0;
      background = [];
      for (let branch = shell; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling !== branch && sibling instanceof HTMLElement && !sibling.matches('script,style,link,template')) background.push([sibling, sibling.inert]);
        }
      }
      background.forEach(([el]) => { el.inert = true; });
      document.body.style.overflow = 'hidden'; sync();
      menu.querySelector('a')?.focus({preventScroll:true});
    }
    burger.addEventListener('click', () => open ? close(true) : show(), {signal});
    shell.addEventListener('click', e => { if (e.target.closest('a')) close(true); }, {signal});
    document.addEventListener('keydown', e => {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'Tab') return;
      const links = [...shell.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.getClientRects().length && !el.closest('[inert]'));
      const first = links[0], last = links.at(-1);
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, {signal});
    document.addEventListener('focusin', e => {
      if (open && !shell.contains(e.target)) menu.querySelector('a')?.focus({preventScroll:true});
    }, {signal});
    document.addEventListener('pc:chatopen', () => close(true), {signal});
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-pc-scroll]');
      if (!link || !(header.contains(link) || menu.contains(link))) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      e.preventDefault(); close();
      const top = target.getBoundingClientRect().top + scrollY - header.offsetHeight - 18;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollTo({top, behavior: reduced || Math.abs(top-scrollY) > innerHeight*1.5 ? 'auto' : 'smooth'});
      // Keyboard navigation lands at the requested section instead of in a closed menu.
      const focusTarget = target.matches('h1,h2,h3') ? target : target.querySelector('h1,h2,h3') || target;
      if (!focusTarget.hasAttribute('tabindex')) { focusTarget.setAttribute('tabindex','-1'); focusTarget.addEventListener('blur',()=>focusTarget.removeAttribute('tabindex'),{once:true}); }
      focusTarget.focus({preventScroll:true});
    }, {signal});
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, {passive:true,signal});
    window.addEventListener('resize', () => {
      if (innerWidth > 1129 && open) {
        const restoreFocus = shell.contains(document.activeElement);
        close();
        if (restoreFocus) header.querySelector('.pc-primary-cta')?.focus({preventScroll:true});
      }
      sync();
    }, {signal});
    const resize = new ResizeObserver(sync); resize.observe(header);
    menu.inert = true; sync();
    dispose = () => { close(); abort.abort(); resize.disconnect(); cancelAnimationFrame(frame); };
  }
  window.PCHeader = {init, destroy: () => dispose?.()};
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector('[data-pc-header]')) init(); });
  document.addEventListener('shopify:section:unload', e => { if (e.target.querySelector('[data-pc-header]')) dispose?.(); });
  init();
})();
